import { render, staticRenderFns } from "./auditComicMain.vue?vue&type=template&id=315b30cd"
import script from "./auditComicMain.vue?vue&type=script&lang=js"
export * from "./auditComicMain.vue?vue&type=script&lang=js"
import style0 from "./auditComicMain.vue?vue&type=style&index=0&id=315b30cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports